import React from "react";
import {
	Button,
	Card,
	CardBody,
	Container,
	CardHeader,
	Input,
	toast,
	MDBIcon,
} from "mdbreact";
import { ToastContainer } from "react-toastify";
import InsuranceService from "../Security/InsuranceService/insuranceService";
import ReactTooltip from "react-tooltip";

export default class addInsurance extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			name: "",
			order: "",
			errorMessage: "",
		};
	}

	nameChange = (e) => {
		this.setState({
			name: e.target.value,
		});
	};

	orderChange = (e) => {
		this.setState({
			order: e.target.value,
		});
	};

	renderAddInsuranceButton() {
		return (
			<div>
				<p style={{ color: "red" }}>{this.state.errorMessage}</p>
				<Input
					label={"Payor Source Name"}
					onChange={this.nameChange.bind(this)}
					value={this.state.name}
				/>
				<Input
					label={"Order Number"}
					onChange={this.orderChange.bind(this)}
					value={this.state.order}
				/>
			</div>
		);
	}

	addSaveButtonClick = () => {
		if (this.validate()) {
			let n = this.state.name,
				h = this.state.order;
			let obj = {
				order: h,
				name: n,
			};
			return InsuranceService.createInsurance(obj)
				.then((res) => {
					this.setState({
						errorMessage: "",
						name: "",
						order: "",
					});
					toast.success(n + " Payor Source has been Added!");
				})
				.catch((err) => {
					toast.warn("An error occurred adding a new product");
				});
		}
	};

	validate() {
		let n = this.state.name,
			h = this.state.order;
		if (n === "") {
			this.setError("Please enter a product name");
			return false;
		} else if (h === "") {
			this.setError("Please enter an order number");
			return false;
		}
		return true;
	}

	setError(e) {
		this.setState({
			errorMessage: e,
		});
	}

	render() {
		return (
			<div>
				<ToastContainer
					hideProgressBar={false}
					newestOnTop={true}
					autoClose={3000}
				/>
				<Container className="mt-5">
					<Card>
						<CardHeader
							color={"blue-grey lighten-2"}
							style={{ textAlign: "center" }}
						>
							<Button
								style={{ float: "left" }}
								floating
								size="sm"
								color={"warning"}
								data-tip={"Back"}
								onClick={() => this.props.history.push("/insurance")}
							>
								<MDBIcon icon="backward" style={{ fontSize: "2em" }} />
							</Button>
							Add New Payor Source
							<Button
								style={{ float: "right" }}
								floating
								size="sm"
								color={"success"}
								data-tip={"Save New Payor Source"}
								onClick={this.addSaveButtonClick}
							>
								<MDBIcon far icon="save" style={{ fontSize: "2em" }} />
							</Button>
						</CardHeader>
						<CardBody>{this.renderAddInsuranceButton()}</CardBody>
					</Card>
					<ReactTooltip />
				</Container>
			</div>
		);
	}
}
